/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* CROSS SELL */

function showCrossSell() {
  
  $.ajax({url: "/cart?view=cross-sell", crossdomain:true, success: function(str){

    var iframe = document.createElement('iframe');
    document.body.appendChild(iframe);
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(str);
    iframe.contentWindow.document.close();
    var content = $('#crosssell',iframe.contentWindow.document).text();
    var arr = JSON.parse(content);

    var obj,
        html = '<div style="text-align:left;padding:4px;"><h4>Haluan lisätä tilaukselleni myös nämä:</h4></div>';
    for(var i=0,j=arr.length;i<j;i++){
      obj = arr[i];
      html += '<a href="/products/'+obj.handle+'"><div style="float:left;width:'+ ( 100 / arr.length ) +'%;"><img style="height:80px;" src="'+obj.imgsrc+'" alt="'+obj.title+'"><div style="display:inline-block;padding-left:4px;padding-top:10px;">'+obj.title+'</div></div></a>';
    }
     
    $('#mini-cart-crossell').html(html);

  }}); 

}